import React, { useRef, useState } from 'react';
import { useInView } from '../hooks';

const AREAS = [
  { name: 'Waterloo', icon: '/icon/placeholder.png', desc: 'SE1 7 · SE1 8', detail: 'Fast response, flexible slots' },
  { name: 'Southwark', icon: '/icon/placeholder.png', desc: 'SE1 0 · SE1 1', detail: 'Regular & one-off cleans' },
  { name: 'London Bridge', icon: '/icon/placeholder.png', desc: 'SE1 2 · SE1 9', detail: 'Airbnb specialist area' },
  { name: 'Elephant & Castle', icon: '/icon/placeholder.png', desc: 'SE1 6 · SE17', detail: 'End of tenancy experts' },
  { name: 'Borough', icon: '/icon/placeholder.png', desc: 'SE1 1 · SE1 3', detail: 'Residential & commercial' },
  { name: 'Bermondsey', icon: '/icon/placeholder.png', desc: 'SE1 3 · SE1 5', detail: 'Short let specialists' },
];

function AreaCard({ name, icon, desc, detail, delay, inView }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'var(--navy)' : '#fff',
        border: `1.5px solid ${hovered ? 'var(--sky)' : 'var(--border)'}`,
        borderRadius: 14,
        padding: '14px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: 'all 0.4s ease',
        transitionDelay: `${delay}ms`,
      }}
    >
      <div
        style={{
          width: 38,
          height: 38,
          minWidth: 38,
          background: hovered ? 'rgba(245,140,30,0.15)' : 'var(--cream)',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={icon} alt={name} style={{ width: 22, height: 22 }} />
      </div>

      <div>
        <div style={{ fontWeight: 700, fontSize: '0.82rem', color: hovered ? '#fff' : 'var(--navy)' }}>
          {name}
        </div>

        <div style={{ fontSize: '0.68rem', color: hovered ? 'var(--orange)' : 'var(--muted)' }}>
          {desc}
        </div>

        <div style={{ fontSize: '0.68rem', color: hovered ? 'rgba(255,255,255,0.6)' : 'var(--muted)' }}>
          {detail}
        </div>
      </div>
    </div>
  );
}

export default function Areas() {
  const ref = useRef(null);
  const inView = useInView(ref, 0.1);

  return (
    <section id="areas" style={{ padding: '60px 5%', background: 'var(--cream)' }}>
      <style>{`

      .areas-layout {
        display: flex;
        gap: 40px;
        max-width: 1200px;
        margin: auto;
      }

      .areas-map {
        flex: 1;
      }

      .areas-cards {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 14px;
      }

      .areas-grid {
        display: grid;
        grid-template-columns: repeat(2,1fr);
        gap: 12px;
      }

      /* Tablet + phone */
      @media (max-width: 768px) {

        .areas-layout {
          flex-direction: column;
        }

        .areas-map iframe {
          height: 260px;
        }

        .areas-grid {
          grid-template-columns: 1fr;
        }

      }

      `}</style>

      <div
        ref={ref}
        style={{
          textAlign: 'center',
          maxWidth: 600,
          margin: '0 auto 40px',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(20px)',
          transition: '0.6s'
        }}
      >
        <h2 style={{ fontSize: 'clamp(1.5rem,4vw,2.4rem)', color: 'var(--navy)' }}>
          Areas We Cover in SE1
        </h2>

        <p style={{ color: 'var(--muted)' }}>
          Based in the heart of South London, we cover all SE1 postcodes.
        </p>
      </div>

      <div className="areas-layout">

        <div className="areas-map" style={{ borderRadius:20, overflow:'hidden' }}>
          <iframe
            title="SE1 London Map"
            src="https://www.google.com/maps?q=SE1+London&output=embed"
            width="100%"
            height="440"
            style={{ border:0 }}
          />
        </div>

        <div className="areas-cards">

          <div style={{
            background:'var(--navy)',
            borderRadius:14,
            padding:'16px',
            color:'#fff'
          }}>
            <strong>All SE1 Postcodes</strong>
            <div style={{ fontSize:'.8rem', opacity:.7 }}>
              SE1 0 → SE1 9 · SE17 · SE16
            </div>
          </div>

          <div className="areas-grid">
            {AREAS.map((area,i)=>(
              <AreaCard key={area.name} {...area} delay={i*80} inView={inView}/>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
}